<template>
  <v-container fluid class="d-flex justify-center align-center" style="height: 100vh">
    <v-card width="500" height="fit-content" flat>
      <v-container>
        <v-row>
          <v-col>
            <h3 v-text="'Pre loading'" class="text-center useThemeTextColor" />
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-progress-linear :value="completedprecentage" height="10" stream buffer-value="0"
              class="rounded-pill preloading-progress">
            </v-progress-linear>
          </v-col>
        </v-row>
        <v-row>
          <v-col>{{completedcount}} of {{totalcount}} done</v-col>
          <v-spacer />
          <v-col class="text-right">{{completedprecentage}}%</v-col>
        </v-row>
        <!--
        <v-row>
          <v-col>
            <v-list dense>
              <v-list-item v-for="(wrapper, key) in $store.state.BackgroundUpdater"
                           :key="key">
                <v-list-item-content>
                  <v-list-item-title>
                    {{key}}
                  </v-list-item-title>
                </v-list-item-content>
                <v-list-item-icon>
                  <v-progress-circular v-if="wrapper.Loading"
                                       indeterminate
                                       size="20"
                                       width="2"
                                       color="tertiary">
                  </v-progress-circular>
                  <v-icon v-else
                          color="quaternary"
                          size="20">mdi-check</v-icon>
                </v-list-item-icon>
              </v-list-item>
            </v-list>
          </v-col>
        </v-row>
        -->
      </v-container>
    </v-card>
  </v-container>
</template>


<script>
export default {
  name: "PreLoading",
  props: {},
  components: {},

  data() {
    return {};
  },

  methods: {},

  computed: {
    completedprecentage() {
      return Math.round((this.completedcount / this.totalcount) * 100);
    },

    completedcount() {
      var backgroundUpdaterCompletedTasks = Object.keys(this.$store.state.BackgroundUpdater).filter(
        (x) => !this.$store.state.BackgroundUpdater[x].Loading && this.$store.state.BackgroundUpdater[x].Value != null
      ).length;
      if (!this.userInfoLoading) {
        backgroundUpdaterCompletedTasks++;
      }
      return backgroundUpdaterCompletedTasks;
    },

    totalcount() {
      return Object.keys(this.$store.state.BackgroundUpdater).length + 1;
    },

    userInfoLoading() {
      return this.$store.getters["userInfoLoading"];
    },
  },

  watch: {},
};
</script>


<style lang='scss'>
.v-progress-linear.preloading-progress .v-progress-linear__determinate {
  background-image: linear-gradient(to right, #0287ed, #44c3e5) !important;
}
</style>